import React, { useState, useEffect } from "react";
import {
  Wrapper,
  MenuTextButton,
  MenuTextLink,
  MenuWrapper,
  MenuSocialButton,
  MenuButton,
} from "./index.styled";
import { useHeaderColor } from "context";
import { useStaticQuery, graphql } from "gatsby";
import { CSSTransition } from "react-transition-group";
import Menu from "./menu";

const Header = ({ className }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const data = useStaticQuery(graphql`
    query HeaderQuery {
      menuContent {
        content {
          copyright
          legalLinks {
            text
            url
          }
          mainList {
            subItems {
              text
              url
              anchor
              divider
            }
            text
            url
          }
          secondList {
            url
            text
          }
          socialLinks {
            link
            text
          }
        }
      }
    }
  `);
  const { headerState, setHeaderState } = useHeaderColor();
  const content = data.menuContent.content[0];

  useEffect(() => {

    const script = document.createElement("script");
    script.src = "https://cdn.callrail.com/companies/947260113/961782180f55d57a93d1/12/swap.js";
    script.id = "callrail-js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      const existingScript = document.getElementById("callrail-js");
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };

  }, []);

  useEffect(() => {
    // Create script element
    const script = document.createElement('script');
    script.src = "https://app.trypath.io/ai-tour-widget.js";
    script.setAttribute('show-agent-image', 'false');
    script.setAttribute('backend-api-endpoint', 'https://path-intelligence-793200f813cb.herokuapp.com/api/v1');
    script.setAttribute('frontend-api-endpoint', 'https://app.trypath.io');
    script.setAttribute('property-uuid', '3f203e8c-ec87-416e-adfd-cc9f0c4be01a');
    script.setAttribute('logo-file', 'logo-path-white-no-word.png');
    script.setAttribute('logo-full-file', 'path-logo-white-full.png');
    script.setAttribute('widget-position', 'bottom-left');
    script.async = true;

    // Append script to document
    document.body.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []); // Empty dependency array means this effect runs once on mount

  return (
    <>
      <Wrapper className={className} $state={headerState}>
        <div></div>
        <MenuWrapper>
          {/* <MenuTextButton type="button">watch the FILM</MenuTextButton> */}
          <MenuTextLink to="/contact">CONTACT</MenuTextLink>
          <MenuSocialButton
            target="_blank"
            href={content.socialLinks[0].link}
          />
          <MenuButton onClick={toggleMenu} />
        </MenuWrapper>
        <CSSTransition
          in={isOpen}
          timeout={300}
          classNames="menu"
          unmountOnExit
        >
          <Menu data={content} onClick={toggleMenu} />
        </CSSTransition>
      </Wrapper>
    </>
  );
};

export default Header;
